module.exports = __webpack_public_path__ + "img/bj-album-cover-thumb.55b1ae82.jpg";